import { Controller } from "stimulus";
import axios from "axios";
import autocomplete from "autocomplete.js";
import Mustache from "mustache";

export default class extends Controller {
  static targets = ["field", "idField", "suggestionTemplate"];

  source() {
    const url = this.data.get("url");
    return (q, callback) => {
      axios.get(url, { params: { q } }).then((response) => {
        callback(response.data);
      });
    };
  }

  connect() {
    const suggestionTemplate = this.suggestionTemplateTarget.innerHTML;

    this.ac = autocomplete(this.fieldTarget, { hint: false }, [
      {
        source: this.source(),
        debounce: 200,
        templates: {
          suggestion: (suggestion) => {
            return Mustache.render(suggestionTemplate, suggestion);
          },
        },
      },
    ]).on("autocomplete:selected", (event, suggestion, dataset, context) => {
      this.fieldTarget.dataset.suggestion = JSON.stringify(suggestion);
      this.ac.autocomplete.setVal(suggestion.title);
      this.idFieldTarget.value = suggestion.id;
      if ($('.edit-school-name').length > 0) {
        $(this.idFieldTarget).trigger('change');
      }
    });
  }
}

